import React, { useState } from 'react';
import '../styles/FVDAMDemo.css';

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie) {
    document.cookie.split(';').forEach(c => {
      const [k, v] = c.trim().split('=');
      if (k === name) {
        cookieValue = decodeURIComponent(v);
      }
    });
  }
  return cookieValue;
}

export default function FVDAMDemo() {
  const [form, setForm] = useState({
    numFibers: 25,
    fiber_volume_fraction: 50,
    std_r: 25,
    loading_option: 1,
    elastic_fiber_properties: {},
    elastic_plastic_matrix_properties: {}
  });
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (field, value) => {
    setForm(prev => ({
      ...prev,
      [field]: ['std_r', 'numFibers', 'fiber_volume_fraction', 'loading_option'].includes(field)
        ? Number(value)
        : value
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await fetch('http://localhost:8000/api/run_demo/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': getCookie('csrftoken'),
        },
        body: JSON.stringify(form)
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setResults(data)
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fvdam-demo">
      <h2>Integrated API based on FVDAM</h2>
      
      <div className="form-section">
        <h3>Define unit-cell microstructure:</h3>
        <p>Specify the number of fibers in the unit cell, along with fiber volume fraction and their size statistics.</p>
        
        <div className="input-group">
          <label>Step 1 - input the number of fibers:</label>
          <input
            type="number"
            value={form.numFibers}
            onChange={e => handleChange('numFibers', e.target.value)}
            min="1"
          />
        </div>
        
        <div className="input-group">
          <label>Step 2 - input the fiber volume fraction (%):</label>
          <input
            type="range"
            min="0"
            max="100"
            value={form.fiber_volume_fraction}
            onChange={e => handleChange('fiber_volume_fraction', e.target.value)}
          />
          <span>{form.fiber_volume_fraction}%</span>
        </div>
        
        <div className="input-group">
          <label>Step 3 - input the relative standard deviation of fiber radii (%):</label>
          <input
            type="range"
            min="0"
            max="100"
            value={form.std_r}
            onChange={e => handleChange('std_r', e.target.value)}
          />
          <span>{form.std_r}%</span>
        </div>
        
        <button className="generate-btn">Generate microstructure</button>
        <p>Fibers are in yellow and matrix is in black.</p>
      </div>

      <div className="form-section">
        <h3>Specify composite material properties:</h3>
        <p>The two-phase composite material is composed of the fiber and matrix.</p>
        
        <div className="material-properties">
          <div>
            <h4>Elastic fiber properties:</h4>
            <ul>
              <li>Isotropic</li>
              <li>Transversely isotropic</li>
            </ul>
            <p>The fiber has its elastic modulus and Poisson's ratio.</p>
            <button className="edit-btn">Click here to view/edit</button>
          </div>
          
          <div>
            <h4>Elastic-plastic matrix properties:</h4>
            <ul>
              <li>Isotropic</li>
            </ul>
            <p>The matrix has its elastic modulus, Poisson's ratio, yield strength and hardening slope.</p>
            <button className="edit-btn">Click here to view/edit</button>
          </div>
        </div>
      </div>

      <div className="form-section">
        <h3>Run FVDAM:</h3>
        
        <div className="input-group">
          <label>Loading option:</label>
          <p>Choose one of the six loading conditions.</p>
          <select
            value={form.loading_option}
            onChange={e => handleChange('loading_option', e.target.value)}
          >
            {[1, 2, 3, 4, 5, 6].map(option => (
              <option key={option} value={option}>Option {option}</option>
            ))}
          </select>
        </div>
        
        <button className="execute-btn" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Executing...' : 'Execute FVDAM'}
        </button>
      </div>

      <div className="form-section">
        <h3>Download FVDAM results:</h3>
        <p>Enter your path here</p>
        <input type="text" placeholder="Path to save results" />
        <p>If no path is specified, the files will be saved in the program's current directory.</p>
      </div>

      {error && <div className="error-message">Error: {error}</div>}

      {results && (
        <div className="results-section">
          <h3>Results</h3>
          {results.visualization ? (
            <img
              src={results.visualization}
              alt="Generated microstructure"
              className="result-image"
            />
          ) : (
            <p>No visualization data available</p>
          )}
        </div>
      )}
    </div>
  );
}